import { baseApi } from './baseApi';

export interface PaymentLog {
  id: string;
  traceId: string;
  ihNoOrCart: number;
  title: string;
  description: string;
  status: string;
  ip: string | null;
  closure: any | null;
  payload: any | null;
  endpoint: string;
  createdAt: string;
}

export interface PaymentDetails {
  id: string;
  status: string;
  gatewayClicked: string;
  ihNoOrCart: number;
  gateway: string;
  fund: string;
  createdAt: string;
  updatedAt: string;
  reqJson: string;
  folioNo?: string;
  assetName?: string;
}

export interface PaymentListParams {
  page: number;
  limit: number;
  search?: string;
  status?: string;
  amcId?: string;
  gateway?: string;
  trtype?: string;
  paymode?: string;
  assetId?: string;
}

export interface PaymentListResponse {
  data: PaymentDetails[];
  meta: any;
}

export interface PaymentDetailsResponse {
  data: PaymentDetails;
}

export interface PaymentLogsResponse {
  logs: PaymentLog[];
}

export interface AltPayOption {
  name: string;
  authMode: string;
  id: string;
  label: string;
}

export interface AltPayOptionsResponse {
  options: AltPayOption[];
  time: number;
}

export interface RetryPayload {
  ihNoOrCart: number | string;
  fund: string;
  newAuthMode: string;
  upiVPA?: string;
}

// Dashboard-related interfaces have been moved to dashboardApi.ts

export const paymentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentList: builder.query<PaymentListResponse, PaymentListParams>({
      query: (params) => ({
        url: '/payments/',
        params: {
          page: params.page,
          limit: params.limit,
          search: params.search,
          status: params.status,
          amcId: params.amcId,
          gateway: params.gateway,
          trtype: params.trtype,
          paymode: params.paymode,
          assetId: params.assetId,
        },
      }),
      providesTags: ['Payment'],
    }),

    getPaymentById: builder.query<PaymentDetailsResponse, string>({
      query: (id) => `/payments/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Payment', id }],
    }),

    getPaymentLogsById: builder.query<PaymentLogsResponse, string>({
      query: (id) => `/payments/logs/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'PaymentLog', id }],
    }),

    getAltPayOptions: builder.query<AltPayOptionsResponse, { refNo: string; fund: string }>({
      query: ({ refNo, fund }) => `/payments/alt-payoptions/${refNo}/${fund}`,
      providesTags: ['Payment'],
    }),

    retryPayment: builder.mutation<any, RetryPayload>({
      query: (payload) => ({
        url: '/payments/retry',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Payment'],
    }),

    verifyVpa: builder.mutation<any, { vpa: string }>({
      query: (payload) => ({
        url: '/validate/verify-vpa',
        method: 'POST',
        body: payload,
      }),
    }),

    // Dashboard-related endpoints have been moved to dashboardApi.ts
  }),
});

export const {
  useGetPaymentListQuery,
  useLazyGetPaymentListQuery,
  useGetPaymentByIdQuery,
  useGetPaymentLogsByIdQuery,
  useGetAltPayOptionsQuery,
  useRetryPaymentMutation,
  useVerifyVpaMutation,
} = paymentApi;
